
import { computed, defineComponent, PropType, toRefs } from 'vue';
import { getLayoutSizeStyle } from '@/uikit/image-viewer/image-helpers';
import NBbox from '../bbox/NBbox.vue';
import { Point, Size } from '../bbox/types';
import { BboxConfig } from '../bbox/types';

function orderBySquare(a: BboxConfig, b: BboxConfig) {
  let aSquare = a.box.w * a.box.h,
    bSquare = b.box.w * b.box.h;
  if (aSquare < bSquare) return 1;
  if (aSquare > bSquare) return -1;
  return 0;
}

export default defineComponent({
  name: 'NImageViewerBboxLayer',
  components: { NBbox },
  props: {
    selectable: { type: Boolean, default: true },
    size: { type: Object as PropType<Size>, required: true },
    scale: { type: Number, default: 1 },
    offset: { type: Object as PropType<Point>, default: () => ({ x: 0, y: 0 }) },
    bboxes: { type: Array as PropType<BboxConfig[]>, default: () => [] }
  },
  emits: ['select'],
  setup(props, { emit }) {
    const style = computed(() => getLayoutSizeStyle(props.size, props.offset, props.scale));
    const orderedBboxes = computed(() => props.bboxes.slice().sort(orderBySquare));

    function handleSelect(payload: BboxConfig) {
      emit('select', payload);
    }

    return {
      ...toRefs(props),
      style,
      handleSelect,
      orderedBboxes
    };
  }
});
